export const makeFraction = (number: number, counter: number) => {
  const fractionNumber = String(number).split('')
  fractionNumber.splice(-counter, 0, ',')
  return fractionNumber.join('')
}
